module.exports = __webpack_public_path__ + "images/bannerES-fbdd44c18fbec77df2fd17b535452713.png";